<template>
  <div class="publicCultureBox">
    <div class="main">
      <ul>
        <li>
          <p class="label">认证名称</p>
          <div class="content">
            <p class="text" v-if="disable">{{ info.name }}</p>
            <input v-else type="text" v-model="info.name" placeholder="填写入驻后显示名称" />
          </div>
        </li>
      </ul>
      <ul>
        <li>
          <p class="label">运营者姓名</p>
          <div class="content">
            <p class="text" v-if="disable">{{ info.contacts }}</p>
            <input v-else type="text" v-model="info.contacts" placeholder="请填写运营姓名" />
          </div>
        </li>
        <li>
          <p class="label">身份证号</p>
          <div class="content">
            <p class="text" v-if="disable">{{ info.cardid }}</p>
            <input v-else type="text" v-model="info.cardid" placeholder="请输入身份证号" maxlength="18" />
          </div>
        </li>
        <li>
          <p class="label">手机号</p>
          <div class="content">
            <p class="text" v-if="disable">{{ info.contactstel }}</p>
            <input
              v-else
              type="text"
              v-model="info.contactstel"
              placeholder="请输入手机号"
              maxlength="11"
            />
          </div>
        </li>
        <li>
          <p class="label">所在地</p>
          <div class="content">
            <div
              :class="['select', info.city ? 'active' : '']"
              @click.stop="disable ? '' : address()"
            >
              <p>{{ info.city ? info.city : "请选择所在地" }}</p>
            </div>
          </div>
        </li>
      </ul>
      <ul>
        <li class="tb">
          <p class="label">机构全称</p>
          <div class="content">
            <p
              ref="fullnameAutoHeight"
              :class="['autoHeight', disable ? 'showHeight' : '']"
            >{{ info.fullname }}</p>
            <textarea
              ref="placeholderAutoHeight"
              v-if="!disable"
              :style="{ height: placeholderHeight+fullnameHeight + 'px' }"
              type="text"
              v-model="info.fullname"
              :placeholder="
                businesstype == '1002'
                  ? '机构名称需与营业执照上的名称一致'
                  : '机构名称需与事业单位法人证明或组织机构代码证上的名称一致'
              "
            ></textarea>
          </div>
        </li>
        <li>
          <p class="label">艺术类型</p>
          <div class="content">
            <div
              :class="['select', selectIndex != -1 ? 'active' : '']"
              @click.stop="disable ? '' : (showToast = true)"
            >
              <p>
                {{
                selectIndex != -1
                ? artClassList[selectIndex].shortnamecn
                : "请选择机构的艺术类型"
                }}
              </p>
            </div>
          </div>
        </li>
        <li class="tb">
          <p class="label">经营范围</p>
          <div class="content">
            <p
              ref="industryAutoHeight"
              :class="['autoHeight', disable ? 'showHeight' : '']"
            >{{ info.industry }}</p>
            <textarea
              v-if="!disable"
              type="text"
              :style="{ height: industryHeight + 'px' }"
              v-model="info.industry"
              placeholder="请填写与营业执照主营范围内的一致的内容"
            ></textarea>
          </div>
        </li>
        <li>
          <p class="label">统一社会信用代码</p>
          <div class="content">
            <input
              type="text"
              v-model="info.certificatecode"
              maxlength="18"
              placeholder="请填写统一社会信用代码"
            />
          </div>
        </li>
        <li class="tb imgBox">
          <p class="label">事业单位证明/营业执照 ({{ info.businessLicenseimageList.length }}/5)</p>
          <div class="content">
            <ul class="imgList">
              <!-- 展示图片 -->
              <li
                class="picture"
                v-for="(item, index) in info.businessLicenseimageList"
                :key="index"
              >
                <img
                  :src="
                    (disable ? '' : $store.state.state.userImgUrl) +
                    item.originimage
                  "
                />
                <i v-if="!disable" @click="del('businessLicense', index)"></i>
              </li>
              <!-- 点击上传 -->
              <li v-if="info.businessLicenseimageList.length < 5 && !disable">
                <input
                  type="file"
                  class="upload"
                  @change="addImg"
                  ref="businessLicense"
                  multiple="multiple"
                  accept="image/*;capture=camera"
                  data-type="businessLicense"
                />
                <div class="add">
                  <img src="@/assets/img/app/camera.png" />
                  <span>上传图片</span>
                </div>
              </li>
            </ul>
            <p
              class="tip"
            >每张小于2M，支持JPG/PNG等格式，最多上传5张图片。上传资料要求：请上传高清彩色版事业单位法人证明/组织机构代码证，或加盖红色公章的复印件（非电子公章），请确保材料完成清晰，便于识别。</p>
          </div>
        </li>
        <li class="tb imgBox">
          <p class="label">法人证件 ({{ info.legalPersonimageList.length }}/5)</p>
          <div class="content">
            <ul class="imgList">
              <!-- 展示图片 -->
              <li class="picture" v-for="(item, index) in info.legalPersonimageList" :key="index">
                <img
                  :src="
                    (disable ? '' : $store.state.state.userImgUrl) +
                    item.originimage
                  "
                />
                <i v-if="!disable" @click="del('legalPerson', index)"></i>
              </li>
              <!-- 点击上传 -->
              <li v-if="info.legalPersonimageList.length < 5 && !disable">
                <input
                  type="file"
                  class="upload"
                  @change="addImg"
                  ref="legalPerson"
                  multiple="multiple"
                  accept="image/*;capture=camera"
                  data-type="legalPerson"
                />
                <div class="add">
                  <img src="@/assets/img/app/camera.png" />
                  <span>上传图片</span>
                </div>
              </li>
            </ul>
            <p
              class="tip"
            >证件包含：身份证、护照、来往内地通行证等有效证件；照片标准：四角完整，清晰可辩。若加水印需保证照片重要信息清晰可辩；法人证件非大陆身份证（如护照等）时，需提供法人证明涵。</p>
          </div>
        </li>
      </ul>
      <div class="certificate">
        <i :class="rule ? '' : 'disagree'" @click="disable ? '' : (rule = !rule)"></i>
        <p>
          我已经仔细阅读并接受
          <span @click="goAuthentication()">《认证服务协议》</span>
        </p>
      </div>
    </div>
    <div class="but">
      <p
        :class="{ active: allIn, disable: disable }"
        @click="disable ? '' : allIn ? submit('all') : ''"
      >{{ disable ? "审核中，请耐心等待" : "提交申请" }}</p>
    </div>
    <div class="toast" v-if="showToast">
      <div class="toastContent">
        <div class="toastTil">
          <h5>艺术类型</h5>
          <div class="close" @click="showToast = false">
            <img src="@/assets/img/h5/close.png" />
          </div>
        </div>
        <ul>
          <li
            v-for="(item, index) in artClassList"
            :key="index"
            :class="artIndex == index ? 'pick' : ''"
            @click="artIndex = index"
          >
            <p>{{ item.shortnamecn }}</p>
          </li>
        </ul>
      </div>
      <div class="button">
        <p :class="['submit', artIndex != -1 ? 'active' : '']" @click="selectArt()">确认</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  metaInfo() {
    return {
      title: this.title[this.businesstype],
    };
  },
  name: "publicCulture",
  data() {
    return {
      showToast: false,
      rule: true,
      info: {
        name: "",
        contacts: "",
        cardid: "",
        contactstel: "",
        city: "",
        artype: "",
        fullname: "", //机构全称
        industry: "", //经营范围
        certificatecode: "",
        businessLicenseimageList: [], //营业执照
        legalPersonimageList: [], //法人照片
      },
      artClassList: [],
      artIndex: -1,
      selectIndex: -1,
      fullnameHeight: "",
      industryHeight: "",
      businesstype: "",

      placeholderHeight: "", //placeholder

      title: {
        1000: "国家公共文化服务机构",
        1001: "国家文化艺术院团",
        1002: "社会艺术培训机构",
      },
      disable: false, //回看禁止触发
    };
  },
  beforeDestroy() {
    this.util.hideLoading();
  },
  created() {
    this.businesstype = this.$route.query.businesstype
      ? this.$route.query.businesstype
      : 1000;
    //判断是查看申请信息
    if (this.$route.query.examineInfo) {
      this.getexamineInfo();
    } else {
      this.getArt();
    }
  },
  mounted() {
    this.fullnameHeight = this.$refs.fullnameAutoHeight.offsetHeight;
    this.industryHeight = this.$refs.industryAutoHeight.offsetHeight;
    this.placeholderHeight = this.$refs.placeholderAutoHeight.offsetHeight;
  },
  watch: {
    info: {
      handler: function () {
        this.checkInfo();
      },
      deep: true,
    },
    ["info.cardid"]() {
      this.info.cardid = this.info.cardid.replace(/[^\w]/g, "");
    },
    ["info.contactstel"]() {
      this.info.contactstel = this.info.contactstel.replace(/\D/g, "");
    },
    ["info.certificatecode"]() {
      this.info.certificatecode = this.info.certificatecode.replace(
        /[^\w]/g,
        ""
      );
    },
    ["info.fullname"]() {
      this.fullnameHeight = this.$refs.fullnameAutoHeight.offsetHeight;
    },
    ["info.industry"]() {
      this.industryHeight = this.$refs.industryAutoHeight.offsetHeight;
    },
  },

  methods: {
    address() {
      var _this = this;
      var Provinces = function (callback) {
        _this
          .$post("gart-common-api/api/cmn/address/queryAddress", { parentid: 0 })
          .then((res) => {
            if (res.code == 1) {
              var addressData = res.data;
              addressData.splice(-2, 2);
              callback(res.data);
            } else {
              _this.util.toast({ msg: res.message });
            }
          });
      };
      var Citys = function (Provinces, callback) {
        _this
          .$post("gart-common-api/api/cmn/address/queryAddress", {
            parentid: Provinces,
          })
          .then((res) => {
            if (res.code == 1) {
              callback(res.data);
            } else {
              _this.util.toast({ msg: res.message });
            }
          });
      };
      var iosSelect = new IosSelect(2, [Provinces, Citys], {
        type: "address",
        title: "选择所在地",
        itemHeight: 35,
        itemShowCount: 9,
        relation: [1, 1],
        callback: function (selectOneObj, selectTwoObj) {
          _this.info.city = selectOneObj.province + "·" + selectTwoObj.city;
          _this.checkInfo();
        },
      });
    },
    getArt() {
      this.$post("gart-common-api/api/cmn/domaindata/index", {
        domainname: "ARTTYPE",
      }).then((res) => {
        if (res.code == 1) {
          var data = res.data ? res.data : [];
          this.artClassList = data;
          var artype = this.info.artype;
          if (artype && data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].domaincode == artype) {
                this.selectIndex = i;
                this.artIndex = i;
                break;
              }
            }
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    addImg(e) {
      var _this = this;
      var type = e.target.dataset.type;
      var fileList = this.$refs[type].files;
      var oldLength =
        type == "businessLicense"
          ? this.info.businessLicenseimageList.length
          : this.info.legalPersonimageList.length;
      if (fileList.length + oldLength > 5) {
        this.util.toast({ msg: "最多可上传5张" });
        return false;
      }
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size > 2 * 1024 * 1024) {
          this.util.toast({ msg: "请选择2M以内的图片！" });
          return false;
        } else {
          axios
            .get(
              _this.$store.state.state.uploadUrl +
                "iart-api-oss/qiniu/oss/policy",
              { params: { bucket: "MI" } }
            )
            .then((res) => {
              var data = res.data;
              var key = data.key + "." + fileList[i].type.split("/")[1]; //文件资源名
              var token = data.token;
              _this.upload(fileList[i], key, token, type);
            });
        }
        if (i == fileList.length - 1) {
          // this.$refs[type].value = "";
        }
      }
    },
    upload(file, key, token, type) {
      var _this = this;
      _this.util.showLoading();
      var observer = {
        next(res) {},
        error(err) {
          _this.util.hideLoading();
          _this.util.toast({ message: "上传失败" });
        },
        complete(res) {
          _this.util.hideLoading();
          if (type == "businessLicense") {
            _this.info.businessLicenseimageList.push({
              originimage: res.key,
            });
          } else {
            _this.info.legalPersonimageList.push({ originimage: res.key });
          }
        },
      };
      var observable = qiniu.upload(file, key, token);
      var subscription = observable.subscribe(observer); // 上传开始
    },
    del(type, index) {
      if (type == "businessLicense") {
        this.info.businessLicenseimageList.splice(index, 1);
      } else {
        this.info.legalPersonimageList.splice(index, 1);
      }
    },
    selectArt() {
      this.selectIndex = this.artIndex;
      this.showToast = false;
      this.info.artype = this.artClassList[this.artIndex].domaincode.toString();
    },
    checkInfo() {
      var allIn = true;
      var info = this.info;
      for (const key in info) {
        if (info[key].length == 0) {
          allIn = false;
        }
      }
      this.allIn = allIn;
    },
    submit() {
      var info = this.info;
      if (!this.rule) {
        this.util.toast({ msg: "请先阅读并接受协议" });
        return;
      }
      if (!this.util.phoneReg.test(info.contactstel)) {
        this.util.toast({ msg: "请输入正确的手机号" });
        return;
      }
      if (!this.util.idNumberReg.test(info.cardid)) {
        this.util.toast({ msg: "请输入正确的身份证号" });
        return;
      }
      if (this.info.certificatecode.trim().length<18) {
        this.util.toast({ msg: "请输入正确的统一社会信用代码" });
        return;
      }
      info.businesstype = this.businesstype;
      this.util.showLoading();
      this.$post(
        "gart-common-api/api/cmn/auditing/createByplatformAuditing",
        info
      ).then((res) => {
        this.util.hideLoading();
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              this.util.toast({
                msg: "认证资料提交成功",
              });
              // 提交申请后,跳转至审核状态
              this.$router.push({
                path: "/app/application/applicationStates",
                query: { businesstype: info.businesstype },
              });
            } else {
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        } else {
          this.util.login(this);
        }
      });
    },
    goAuthentication() {
      var obj = {
        this: this,
        loginStatus: false,
        url: "/common/protocol/authentication",
      };
      this.util.goto(obj);
    },

    getexamineInfo() {
      this.$post("gart-common-api/api/cmn/auditing/queryByplatformAuditing", {
        businesstype: this.businesstype,
      }).then((res) => {
        if (res.code == 1) {
          this.disable = true;
          var data = res.data;
          var info = this.info;
          for (const key in info) {
            info[key] = data[key];
          }
          this.getArt();
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.publicCultureBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f4f4f7;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow: auto;
    padding: 24px 16px;
    > ul {
      background: #fff;
      border-radius: 8px;
      padding-left: 16px;
      > li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 16px 16px 16px 0;
        .label {
          font-size: 14px;
          line-height: 20px;
          color: #35363c;
          font-weight: 400;
        }
        .content {
          flex: 1;
          position: relative;
          .text,
          input {
            width: 100%;
            text-align: right;
            font-size: 14px;
            line-height: 20px;
            font-weight: 300;
            color: #2d2d2d;
          }
          input::placeholder {
            color: #86878a;
            font-size: 14px;
            font-weight: 300;
            line-height: 20px;
          }
          .select {
            text-align: right;
            font-size: 14px;
            line-height: 20px;
            color: rgba(134, 135, 138, 1);
            p {
              font-weight: 300;
              padding-right: 20px;
              position: relative;
            }
            p::before {
              content: " ";
              display: inline-block;
              width: 16px;
              height: 16px;
              position: absolute;
              top: 50%;
              right: 0;
              margin-top: -8px;
              background: url(../../../assets/img/h5/arrow_right.png) no-repeat;
              background-size: 16px 16px;
            }
          }
          .active {
            color: rgba(45, 45, 45, 1);
          }
        }
      }
      > li.tb {
        flex-direction: column;
        .content {
          margin-top: 16px;
          .imgList {
            li {
              position: relative;
              width: 100px;
              height: 100px;
              display: inline-block;
              text-align: center;
              vertical-align: middle;
              margin-bottom: 6px;
              img {
                width: 100%;
                height: 100%;
                vertical-align: middle;
                border-radius: 4px;
              }
              i {
                width: 24px;
                height: 24px;
                background: url(../../../assets/img/app/del.png);
                background-size: 24px 24px;
                position: absolute;
                top: 4px;
                right: 4px;
              }
              .add {
                width: 100px;
                height: 100px;
                border-radius: 4px;
                background: #f4f4f7;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img {
                  width: 32px;
                  height: 32px;
                }
                span {
                  font-size: 12px;
                  line-height: 17px;
                  color: #ababab;
                }
              }
              input {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                opacity: 0;
              }
            }
          }
          textarea {
            width: 100%;
            font-size: 14px;
            line-height: 20px;
            color: #2d2d2d;
            font-weight: 300;
            overflow: hidden;
            resize: none;
            height: 20px;
          }
          textarea::placeholder {
            color: #86878a;
            font-size: 14px;
            font-weight: 300;
            line-height: 20px;
          }
          .autoHeight {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            z-index: -1;
            width: 100%;
            word-break: break-all;
            visibility: hidden;
            min-height: 20px;
            font-size: 14px;
            line-height: 20px;
            font-weight: 300;
          }
          .showHeight {
            position: relative;
            z-index: 1;
            visibility: visible;
          }
          .tip {
            font-size: 12px;
            line-height: 17px;
            color: rgba(171, 171, 171, 1);
            margin-top: 16px;
          }
        }
      }
      > li.imgBox {
        padding: 16px 15px 16px 0;
        .content {
          ul {
            > li:not(:nth-child(3)){
              margin-right: 6px;
            }
          }
        }
      }
      > li:not(:last-child) {
        border-bottom: 0.5px solid #eaeaea;
      }
    }
    > ul:not(:last-child) {
      margin-bottom: 16px;
    }
    .certificate {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 16px;
      i {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url(../../../assets/img/app/option.png);
        background-size: 16px 16px;
      }
      .disagree {
        background: url(../../../assets/img/app/not_option.png);
        background-size: 16px 16px;
      }
      p {
        font-size: 12px;
        font-weight: 500;
        line-height: 24px;
        color: #35363c;
        margin-left: 8px;
        span {
          color: #c9373d;
        }
      }
    }
  }
  .but {
    padding: 16px 16px 20px;
    background: #ffffff;
    p {
      padding: 16px 0;
      text-align: center;
      border-radius: 8px;
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
      color: #ffffff;
      background: #cecece;
    }
    .active {
      background: #c94c4c;
    }
    .disable {
      background: #fff;
      color: rgba(129, 129, 129, 1);
    }
  }
  .toast {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 3;
    background: rgba(0, 0, 0, 0.5);
    .toastContent {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      background: #ffffff;
      border-radius: 12px 12px 0 0;
      margin-bottom: 70px;
      .toastTil {
        margin-bottom: 15px;
        border-bottom: 0.5px solid #e6e6e6;
        padding: 16px;
        h5 {
          font-size: 22px;
          color: #2d2d2d;
        }
        .close {
          position: absolute;
          top: 16px;
          right: 16px;
          img {
            width: 32px;
            height: 32px;
          }
        }
      }
      ul {
        padding: 0 16px;
        height: 240px;
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: auto;
        li {
          border-radius: 8px;
          border: 1px solid #eaeaea;
          margin-bottom: 16px;
          padding: 15px 16px;
          text-align: left;
          background: #ffffff;
          box-sizing: content-box;
          p {
            font-size: 14px;
            line-height: 20px;
            color: #2d2d2d;
          }
        }
        li.pick {
          border: 2px solid #c94c4c;
          background: #fffbfb;
          padding: 14px 16px;
          p {
            color: #c94c4c;
            font-weight: bold;
          }
        }
      }
    }
    .button {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      padding: 16px;
      background: #ffffff;
      .submit {
        background: #d5d5d5;
        border-radius: 8px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        padding: 16px 0;
        text-align: center;
      }
      .active {
        background: #c94c4c;
      }
    }
  }
}
</style>